import React, { useState, useRef, useEffect } from "react";
import { db } from "../../Hooks/FirebaseConfig";
import { collection, query, where, onSnapshot, doc, getDoc } from "firebase/firestore";
import Cookies from 'js-cookie';
import './chat.css';
import { useDispatch, useSelector } from "react-redux";
import { MemberList } from "../../apis/api/DirectoryApi";

const ChatSidebar = ({ sendData, sidebarVersion }) => {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [ChatUsers, setChatUsers] = useState([]);
  const [Userslist, setUsersList] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [typingTimeout, setTypingTimeout] = useState(null);

  const dropdownRef = useRef();
  const currentUserId = Cookies.get('userID');
  const { MemberData } = useSelector((state) => state.DirectorySlice);
  const loadedUserIds = useRef(new Set());

  const user = JSON.parse(Cookies.get('user'));

  useEffect(() => {
    if (MemberData) {
      setUsersList(MemberData);
    }
  }, [MemberData]);


  const delay = ms => new Promise(res => setTimeout(res, ms));
  const getUserProfiles = async (userIds) => {

    const newUsers = [];
    for (const id of userIds) {
      if (!loadedUserIds.current.has(id)) {

        var userDoc = await getDoc(doc(db, "users", id));

        if (!userDoc.exists()) {
          // console.log('userDoc')
          await delay(2000);
          console.log('userDoc')
          userDoc = await getDoc(doc(db, "users", id.toString()));
        }

        if (userDoc.exists()) {

          if (!loadedUserIds.current.has(id)) {
            console.log('userDoc2', loadedUserIds.current)
            newUsers.push({ id, ...userDoc.data() });
            loadedUserIds.current.add(id);
          }
        }
      }
    }
    return newUsers;
  };

  const processSnapshots = async (snapshot) => {
    const userIds = new Set();

    snapshot.forEach((doc) => {
      const data = doc.data();

      if (data.sender_Id && data.sender_Id !== Number(currentUserId)) {
        userIds.add(data.sender_Id.toString());
      }
      if (data.receiver_Id && data.receiver_Id !== Number(currentUserId)) {
        userIds.add(data.receiver_Id.toString());
      }
    });

    const newProfiles = await getUserProfiles(Array.from(userIds));

    if (newProfiles.length > 0) {
      setChatUsers((prev) => [...prev, ...newProfiles]);
    }
  };

  useEffect(() => {
    if (!currentUserId) return;
    const messagesRef = collection(db, "messages");
    const userIdNum = Number(currentUserId);

    const q = query(messagesRef, where("participants", "array-contains", userIdNum));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      processSnapshots(snapshot);
    });

    return () => unsubscribe();
  }, [currentUserId, sidebarVersion]);

  const getProfileslist = async () => {
    dispatch(MemberList({ userId: currentUserId }));
  };

  useEffect(() => {
    getProfileslist();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  const handleKeyUp = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const timeout = setTimeout(() => {
      filterUsers(value);
    }, 500);

    setTypingTimeout(timeout);
  };

  const filterUsers = (term) => {
    if (!term.trim()) {
      setFilteredUsers([]);
      return;
    }
    const filtered = Userslist.filter((user) =>
      user.full_name.toLowerCase().includes(term.toLowerCase()) ||
      user.company_name?.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredUsers(filtered);
  };

  const handleClick = async (data) => {
    sendData(data);
    setFilteredUsers([]);
    setInputValue('');
  }


  return (
    <>
      <div class="chat-sidebar">
        <div class="chat-sidebar-header">
          <div class="d-flex align-items-center">
            <div class="chat-user-online">

              <img
                src={user.member_logo ||  `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`}
                width={45}
                height={45}
                className="rounded-circle"
                alt=""
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`;
                }}
              />


            </div>
            <div class="flex-grow-1 ms-2">
              <p class="mb-0">{user.fullname}</p>
            </div>
          </div>
          <div class="mb-3"></div>
          <div class="chat-search">
            <div class="input-group input-group-sm search-bar">
              <span class="input-group-text bg-transparent"><i class="bx bx-search"></i></span>
              <input type="text" class="form-control" placeholder="People, groups, & messages" value={inputValue} onChange={(e) => setInputValue(e.target.value)} onKeyUp={handleKeyUp} />
              <span class="input-group-text bg-transparent"><i class="bx bx-dialpad"></i></span>
            </div>
            <div className="user-list-scroll">
              <ul className="user-list">
                {filteredUsers?.map((user) => (
                  <li className="user-item" onClick={() => handleClick(user)} key={user.id}>
                    <img
                      src={user.member_logo ||  `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`}
                      alt="User"
                      className="user-avatar"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/gray-avatar-icon-vector-illustration_276184-163.avif";
                      }}
                    />
                    <div className="user-details">
                      <span className="user-name">{user.full_name}</span>
                      <span className="user-name">{user.company_name}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

          </div>
          <div class="chat-tab-menu mt-3">
            <ul class="nav nav-pills nav-justified">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  data-bs-toggle="pill"
                  href="javascript:;"
                >
                  <div class="font-24">
                    <i class="bx bx-conversation"></i>
                  </div>
                  <div>
                    <small>Chats</small>
                  </div>
                </a>
              </li>

              <li class="nav-item">
                <a
                  class="nav-link"
                  data-bs-toggle="pill"
                  href="javascript:;"
                >
                  <div class="font-24">
                    <i class="bx bx-bell"></i>
                  </div>
                  <div>
                    <small>Notifications</small>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="chat-sidebar-content">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-Chats">
              <div class="p-3">
                <div class="dropdown mt-3">
                  Recent Chats
                </div>
              </div>
              <div class="chat-list scrollable-chat-list">
                <div class="list-group list-group-flush">

                  {ChatUsers?.map((user) => {
                    return (
                      <div class="list-group-item" onClick={() => handleClick(user)}>
                        <div class="d-flex">
                          {/* <div class="chat-user-online"> */}
                          <div >
                            <img
                              src={user.member_logo ||
                                `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`}
                              width="42"
                              height="42"
                              class="rounded-circle"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =`${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`;
                              }}
                              alt=""
                            />
                          </div>
                          <div class="flex-grow-1 ms-2">
                            <h6 class="mb-0 chat-title">{user.full_name}</h6>
                            <p class="mb-0 chat-msg">
                              {user.company_name}
                            </p>
                          </div>
                          <div class="chat-time">< i class='bx  bx-message-dots'  ></i></div>
                        </div>
                      </div>
                    )
                  })}




                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}
export default React.memo(ChatSidebar);